import './style/DashboardLayout.module.css';

import { Button, Flex, Layout } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  MEDIA_QUERIES,
  USER_ACTIVITY_EVENT,
  USER_ACTIVITY_TYPE
} from 'src/enums';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
// import useWindowDimensions from 'src/hooks/useWindowDimensions';
import { userSelectors, useSelector } from 'src/store';
import { useTheme } from 'src/styles/theme';
import { createLog } from 'src/utils';

import AppPrimaryButton from '../appPrimaryButton/AppPrimaryButton';
import SideMenu from './sideMenu';
import classes from './style/DashboardLayout.module.css';
const { Content } = Layout;

const DashboardLayout: React.FunctionComponent<{
  activeRoute: string;
  title?: string;
  children?: JSX.Element;
  subTitle?: string;
}> = (props) => {
  // TOOLS
  const theme = useTheme();
  // HOOKS
  const [menuVisible, setMenuVisible] = React.useState(false);
  // PROPS
  const { activeRoute, children, title, subTitle } = props;
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  // SELECTORS
  const user = useSelector(userSelectors.selectUser);
  const hospital = useSelector(userSelectors.selectUserHospital);
  if (!user) {
    return <h1>no user</h1>;
  }

  const onClickZimunTorim = () => {
    if (!hospital?.zimunTorimLink) {
      console.log('There is no zimun torim link');
      return;
    }

    let zimunTorimLink = hospital.zimunTorimLink;
    if (zimunTorimLink.endsWith('&tkn=')) {
      if (!user) {
        console.log('No user!!!'); //TODO:error modal and error log
        return;
      }
      if (!user.ZimunTorimToken) {
        console.log('No wl token!!!'); //TODO:error modal and error log
        return;
      }

      zimunTorimLink += user.ZimunTorimToken;
    }

    createLog(
      user,
      USER_ACTIVITY_EVENT.VIEW,
      USER_ACTIVITY_TYPE.ZIMUN_TORIM,
      USER_ACTIVITY_TYPE.ZIMUN_TORIM
    );
    window.open(zimunTorimLink, '_blank');
  };

  return (
    <Layout>
      <Button
        className={classes.menuButton}
        onClick={() => setMenuVisible(!menuVisible)}
      >
        <Flex align="center">
          <img src="/assets/icons/menu.png" alt="menu" width={18} height={9} />
          <p className={`${theme.fonts.classNames.mainPageUserName}`}>
            {user.FullName}
          </p>
        </Flex>
      </Button>
      <div className={classes.hederImg}>
        <img
          src={
            (width ?? 0) < MEDIA_QUERIES.MOBILE
              ? 'assets/mobileImg.png'
              : 'assets/header.png'
          }
          alt="header"
          width={'100%'}
          height={280}
        />
      </div>

      <Flex className={classes.contentFlex}>
        {width && width <= MEDIA_QUERIES.TABLET ? (
          <>
            <div
              className={`${classes.overlayContent} ${
                menuVisible ? classes.visible : ''
              }`}
              onClick={() => setMenuVisible(false)}
            ></div>
            <div
              className={`${classes.sideMenuOverlay} ${
                menuVisible ? classes.visible : ''
              }`}
              style={{
                display: menuVisible ? 'block' : 'none'
              }}
            >
              <SideMenu activeKey={activeRoute} />
            </div>
          </>
        ) : (
          <SideMenu activeKey={activeRoute} />
        )}
        <Flex vertical className={classes.titleContainer}>
          <p
            className={`${theme.fonts.classNames.mainPageUserName} ${classes.title}`}
          >
            {title}
          </p>
          <p
            className={`${theme.fonts.classNames.mainPageTitle} ${classes.title}`}
          >
            {subTitle}
          </p>
          <Content style={{ padding: 10, paddingBottom: 50 }}>
            {children}
          </Content>
          {width && width <= MEDIA_QUERIES.TABLET && (
            <Flex justify="center" className={classes.zimunTorimContainer}>
              <AppPrimaryButton
                onClick={onClickZimunTorim}
                className={classes.zimunTorimButton}
              >
                {t('sideMenu.zimunTorim')}
              </AppPrimaryButton>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Layout>
  );
};

export default DashboardLayout;
